var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCvx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.895,
    y1: 5.098,
    x2: 4.045,
    y2: 34.55,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.646 3.261) scale(.6308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1682FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#60D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FCA75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5A5A"
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff"
    },
    cx: 16,
    cy: 16,
    r: 16
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.188 13.502v-5h-2.5v-2.5h-4.999v-2.5h-5v2.5h-5v2.5h-2.5v14.999h2.5v2.5h5V28.5h4.999v-2.499h5v-2.5h2.5v-5h-4.999v2.5h-2.5v2.5h-5v-2.5h-2.498v-9.999h2.5v-2.5h4.999v2.5h2.5v2.5h4.998Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1682FE",
    d: "M17.689 8.376h1.741v2.625h-1.741zM12.685 3.5h1.741v2.625h-1.741z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#60D8A4",
    d: "M7.687 6h1.741v2.625H7.687z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB3B",
    d: "M5.186 16h1.759v7.499H5.186z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#60D8A4",
    d: "M5.186 8.502h1.759v7.499H5.186z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1682FE",
    d: "M20.187 10.875h1.741V13.5h-1.741z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A5A",
    d: "M20.186 18.5h1.741v2.625h-1.741zM17.689 21h1.741v2.625h-1.741zm-5.003 4.874h1.741v2.625h-1.741z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB3B",
    d: "M7.686 23.375h1.741V26H7.686z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.814 13.5v-5h-2.501V6h-4.999V3.5h-5V6h-5v2.5H6.813v15h2.5V26h4.999v2.499h5V26h5.001v-2.5h2.501v-5h-5V21h-2.5v2.5h-5V21h-2.5V11h2.5V8.5h5V11h2.5v2.5h5Z",
    fill: "#3A3A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvx);
export default __webpack_public_path__ + "static/media/cvx.adb0e8d96026434efced5d5876b493af.svg";
export { ForwardRef as ReactComponent };